'use strict';

var { processInclude } = require('./utils/helpers');
import recommendationCarousel from './components/recommendationCarousel';

$(document).ready(function () {
    processInclude(require('./search/search'));
    recommendationCarousel.init();
});
